import { withProps } from 'recompose';
import { prop } from 'ramda';
import { useAppSelector } from 'js/store/hooks';

export const withAvailableGames = withProps(
    ({ gameCodes }) => {
        const games = useAppSelector(prop('games'));
        const availableGames = gameCodes.filter(code => games?.[code]);

        return {
            gameCodes: availableGames
        };
    }
);
